import { atsApiQuery } from '..';

// Mutating a custom field can change the set of offer tokens, so invalidate both
// the custom-field list and the supported-offer-tokens cache — but only when the
// write actually succeeded. Extracted (and exported) so the branch is unit-testable.
const CUSTOM_FIELD_INVALIDATION = [
  { type: 'GetAllCustomFields' },
  { type: 'GetSupportedOfferTokens' },
];

export const invalidateOnCustomFieldResult = (result) =>
  result?.ats_custom_field?.id ? CUSTOM_FIELD_INVALIDATION : [];

export const invalidateOnNoError = ({ error = [] } = {}) =>
  error?.length === 0 ? CUSTOM_FIELD_INVALIDATION : [];

export const customFieldsSettingsApi = atsApiQuery.injectEndpoints({
  endpoints: (builder) => {
    return {
      getAllCustomFields: builder.query({
        providesTags: ['GetAllCustomFields'],
        transformResponse: (response) => response?.data,
        query: ({ apiType }) => {
          return {
            method: 'get',
            url: `ats_custom_fields?subject_type=${apiType}`,
          };
        },
        staleTime: 0,
      }),

      getCustomFields: builder.query({
        transformResponse: (response) => response?.data,
        query: ({ params }) => {
          return {
            params,
            method: 'get',
            url: `ats_custom_fields/form_fields`,
          };
        },
      }),

      createCustomField: builder.mutation({
        transformResponse: (response) => response?.data,
        query: ({ payload }) => {
          return {
            method: 'post',
            url: `/ats_custom_fields`,
            data: { ...payload },
          };
        },
        invalidatesTags: invalidateOnCustomFieldResult,
      }),

      updateCustomField: builder.mutation({
        transformResponse: (response) => response?.data,
        query: ({ payload, fieldId }) => {
          return {
            method: 'put',
            url: `/ats_custom_fields/${fieldId}`,
            data: { ...payload },
          };
        },
        invalidatesTags: invalidateOnCustomFieldResult,
      }),

      updateCustomFields: builder.mutation({
        transformResponse: (response) => response?.data,
        query: ({ apiType, payload }) => {
          return {
            method: 'post',
            url: `/ats_custom_fields/update_form_fields?subject_type=${apiType}`,
            data: { ...payload },
          };
        },
        invalidatesTags: invalidateOnNoError,
      }),

      validateCustomFields: builder.mutation({
        transformResponse: (response) => response?.data,
        query: ({ apiType, payload }) => {
          return {
            method: 'post',
            url: `/ats_custom_fields/validate_offer_form_fields?subject_type=${apiType}`,
            data: { ...payload },
          };
        },
      }),

      deleteCustomField: builder.mutation({
        transformResponse: (response) => response,
        query: ({ fieldId }) => {
          return {
            method: 'delete',
            url: `/ats_custom_fields/${fieldId}`,
          };
        },
        invalidatesTags: invalidateOnNoError,
      }),
    };
  },
  overrideExisting: true,
});

export const {
  useCreateCustomFieldMutation,
  useDeleteCustomFieldMutation,
  useLazyGetAllCustomFieldsQuery,
  useUpdateCustomFieldMutation,
  useGetCustomFieldsQuery,
  useLazyGetCustomFieldsQuery,
  useValidateCustomFieldsMutation,
  useUpdateCustomFieldsMutation,
} = customFieldsSettingsApi;
